import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
import { PAReviewModule } from "@/store/modules/paReview.module";
const reviewMeetingUpsertMachine = Machine({
    id: "reviewMeetingUpsertMachine",
    context: {
        reviewId: "",
        mode: "",
        meetingId: "",
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                INITIALIZE: [
                    {
                        target: "saveMeeting.idle",
                        cond: (context, event) => event.mode === "Add",
                        actions: "assignReviewId",
                    },
                    {
                        target: "editMeeting.idle",
                        actions: ["assignMeetingId"],
                    },
                ],
            },
        },
        saveMeeting: {
            tags: "showUpsertUI",
            initial: "idle",
            states: {
                idle: {
                    tags: "saving",
                    on: {
                        SAVING_MEETING: { target: "savingMeeting" },
                        CANCEL_MEETING: { target: "#reviewMeetingUpsertMachine.idle" },
                    },
                },
                savingMeeting: {
                    invoke: {
                        id: "savingMeeting",
                        src: (context, event) => {
                            return PAReviewModule.saveMeeting(event.reviewMeeting);
                        },
                        onDone: { target: "#reviewMeetingUpsertMachine.notifySuccess", actions: "showSuccessMessage" },
                        onError: { target: "#reviewMeetingUpsertMachine.serviceUnavailable" },
                    },
                },
            },
        },
        editMeeting: {
            initial: "idle",
            states: {
                idle: {
                    always: { target: "gettingMeetingDetails" },
                },
                gettingMeetingDetails: {
                    invoke: {
                        id: "gettingMeetingDetails",
                        src: (context) => {
                            return PAReviewModule.editMeetingDetailById(context.meetingId);
                        },
                        onDone: { target: "loadedMeetingDetails" },
                        onError: { target: "#reviewMeetingUpsertMachine.serviceUnavailable" },
                    },
                },
                loadedMeetingDetails: {
                    tags: "showUpsertUI",
                    on: {
                        UPDATING_MEETING: { target: "updateMeeting" },
                        CANCEL_MEETING: { target: "#reviewMeetingUpsertMachine.idle" },
                    },
                },
                updateMeeting: {
                    invoke: {
                        id: "updateMeeting",
                        src: (context, eve) => {
                            return PAReviewModule.updateMeeting(eve.reviewMeeting);
                        },
                        onDone: { target: "#reviewMeetingUpsertMachine.notifySuccess", actions: "showSuccessMessage" },
                        onError: { target: "#reviewMeetingUpsertMachine.editMeeting.loadedMeetingDetails" },
                    },
                },
            },
        },
        notifySuccess: {
            tags: "showReviewDetailUI",
            after: {
                3000: "idle",
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignReviewId: assign({
            reviewId: (ctx, event) => event.reviewId,
            mode: (ctx, event) => event.mode,
        }),
        assignMeetingId: assign({
            meetingId: (ctx, event) => event.meetingId,
            mode: (ctx, event) => event.mode,
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default reviewMeetingUpsertMachine;
